import { useEffect } from 'react';

import { useUserPrint } from '@app/hooks';

interface UseClientPaymentsListEffectsProps {
  initialSearch(): Promise<void>;
  MassActionButton: JSX.Element;
  isMobile: boolean;
  submitForm(): Promise<void>;
  hideToolbar(): void;
}

export const useClientPaymentsListEffects = ({
  initialSearch,
  isMobile,
  submitForm,
  hideToolbar,
}: UseClientPaymentsListEffectsProps) => {
  const { activeBranchId } = useUserPrint();

  useEffect(() => {
    initialSearch();
  }, [activeBranchId, initialSearch]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        submitForm();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [submitForm]);

  useEffect(() => {
    if (isMobile) {
      hideToolbar();
    }
  }, [isMobile, hideToolbar]);
};
